export default __webpack_public_path__ + "static/media/authorhub.73a36e09.gif";